export interface RetryOptions {
  maxRetries: number
  baseDelayMs: number
  maxDelayMs: number
}

const DEFAULT_OPTIONS: RetryOptions = {
  maxRetries: 3,
  baseDelayMs: 300,
  maxDelayMs: 5000,
}

function isRetryable(status: number): boolean {
  return status >= 500
}

function computeDelay(attempt: number, base: number, max: number): number {
  const exponential = base * Math.pow(2, attempt)
  const jitter = exponential * (0.5 + Math.random() * 0.5)
  return Math.min(jitter, max)
}

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export async function fetchWithRetry(
  input: RequestInfo | URL,
  init?: RequestInit,
  options?: Partial<RetryOptions>
): Promise<Response> {
  const opts = { ...DEFAULT_OPTIONS, ...options }
  let lastError: unknown

  for (let attempt = 0; attempt <= opts.maxRetries; attempt++) {
    try {
      const response = await fetch(input, init)
      if (response.ok || !isRetryable(response.status) || attempt === opts.maxRetries) {
        return response
      }
      lastError = new Error(`HTTP ${response.status}`)
    } catch (err) {
      lastError = err
      if (attempt === opts.maxRetries) break
    }

    await sleep(computeDelay(attempt, opts.baseDelayMs, opts.maxDelayMs))
  }

  throw lastError
}
